import React from 'react';

const PageNotFound = () => {
  const pageStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
    fontSize: '24px',
  };

  return (
    <div style={pageStyle}>
      <h1>OOps! We can't find that page.</h1>
    </div>
  );
};

export default PageNotFound;
